export default {
  user: null,
  chooseUser: null
}
